import React from "react";
import PropTypes from "prop-types";

import styles from "./icon.css";

export const ICON_TYPES = {
  BASE: "base",
  TYPE2: "type2",
  TYPE3: "type3",
  TYPE4: "type4"
};

/**
 * Icon component is used to render svg
 */

function Icon(props) {
  const {
    children,
    highlight = true,
    clickable,
    paddingNone,
    type = ICON_TYPES.BASE,
    onClick,
    onMouseEnter,
    onMouseLeave,
    focussed = false,
    className,
    ...restProps
  } = props;
  const paddingStyle = paddingNone ? 0 : undefined;
  return (
    <div
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className={`${
        (onClick && highlight) || clickable ? styles.clickable : ""
      } ${styles.iconContainer} ${className} ${
        focussed ? styles.focussed : ""
      } ${styles[type]}`}
      onClick={onClick}
      style={{ padding: paddingStyle }}
      {...(onClick ? { role: "button" } : {})}
      {...restProps}
    >
      {children}
    </div>
  );
}

Icon.propTypes = {
  /**
   * Default 8px padding applied in icon component if you don't want padding then pass paddingNone props as true
   */
  paddingNone: PropTypes.bool,
  /**
   * 4 different types icon is rendered
   */
  type: PropTypes.string,
  /**
   * While hover a round circle will be highlighted over the icon
   */
  highlight: PropTypes.bool,
  /**
   * Icon can be clickable by 2 ways one is by passing clickable props as true or if onclick prop is passed, then click action will enabled
   */
  clickable: PropTypes.bool,
  /**
   * Children will be the respected icon to display
   */
  children: PropTypes.element,
  /**
   * If you need to override any style use classname
   */
  className: PropTypes.string,
  /**
   * If user click the icon this function will trigger
   */
  onClick: PropTypes.func,
  /**
   * If user mouse enter the icon this function will trigger
   */
  onMouseEnter: PropTypes.func,
  /**
   * If user mouse leave the icon this function will trigger
   */
  onMouseLeave: PropTypes.func,
  /**
   * Focus prop is true means then the icon will be default focused
   */
  focussed: PropTypes.bool
};

Icon.defaultProps = {
  highlight: true,
  type: ICON_TYPES.BASE,
  focussed: false
};

export { Icon };
